import i18n from 'i18next';

export const TAGS_FILTER_FIELDS = [
	{
		name: 'name',
		label: i18n.t('filters:fields.name'),
		type: 'text',
		required: false,
		labelColumn: 3,
		inputColumn: 9
	}
];
